export default __webpack_public_path__ + "static/media/mobile-background-numbers.a1ba30ec.jpg";